import { createPortal } from "react-dom";
import Toast from "./Toast";

type ToastMessage = {
  id: string;
  message: string;
  type: "success" | "error" | "info";
};

type ToastContainerProps = {
  toasts: ToastMessage[];
  onRemove: (id: string) => void;
};

export default function ToastContainer({
  toasts,
  onRemove,
}: ToastContainerProps) {
  return createPortal(
    <div
      className="fixed left-4 right-4 top-20 z-50 flex max-w-md flex-col gap-3 sm:left-auto sm:w-full"
      data-tour="save-toast"
    >
      {toasts.map((toast) => (
        <Toast
          key={toast.id}
          message={toast.message}
          type={toast.type}
          onClose={() => onRemove(toast.id)}
        />
      ))}
    </div>,
    document.body,
  );
}
